import { fromJS, Map } from 'immutable';
import { LOGIN, LOGIN_FAILURE, LOGIN_RUNNING, LOGIN_SUCCESS, LOGOUT } from './constants';
import { User } from '../services/types';

interface LoginState {
  accessToken: string | null;
  loggingIn: boolean;
  error: string | null;
  user: User | null;
}

const initialState = fromJS({
  accessToken: null,
  loggingIn: false,
  error: null,
  user: null,
}) as Map<keyof LoginState, any>;

interface LoginAction {
  type: string;
  payload?: Map<string, any>;
}

function reducer(state = initialState, action: LoginAction) {
  switch (action.type) {
    case LOGIN:
    case LOGIN_RUNNING:
      return state.set('loggingIn', true) // show UI of loggingIn
        .set('error', null);

    case LOGIN_SUCCESS:
      return state.set('accessToken', action.payload?.get('accessToken'))
        .set('user', action.payload?.get('user'))
        .set('loggingIn', false);

    case LOGIN_FAILURE:
      return state.set('loggingIn', false)
        .set('error', action.payload?.get('error'));

    case LOGOUT:
      return state.set('accessToken', initialState.get('accessToken'));

    default:
      return state;
  }
}

export default reducer;
